// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QU0V","colMin":"styles_colMin__3s-Hh"};